// this file is automatically generated by git.revision.js script
export const versions = { revision: '52ea9ba6f9' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '52ea9ba6f9';
